module.exports = {}.hasOwnProperty
